/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import UIIcon from 'components/UI/Icon/Icon';
import { User } from 'components/User/types';
import useClickOutside from 'components/UI/useClickOutside';
import BaseButton from '@UIComponents/BaseButton/BaseButton';

function AppHeaderHelpMenu({
  user,
  onLogout,
  reportingOutcomeFeatureFlag,
  reportingOutcomeLocalStorage,
  setReportingOutcomeLocalStorage,
  isCreatorCampaignPage,
}: {
  user: User;
  onLogout: () => void;
  reportingOutcome?: boolean;
  reportingOutcomeFeatureFlag?: boolean;
  reportingOutcomeLocalStorage?: boolean | null;
  setReportingOutcomeLocalStorage?: (arg0: boolean | null) => void;
  isCreatorCampaignPage?: boolean;
}) {
  const userName = user && `${user.firstName} ${user.lastName}`;
  const [isOpenHeaderDropdown, setIsOpenHeaderDropdown] = useState(false);
  const toggleDropdown = () => setIsOpenHeaderDropdown(!isOpenHeaderDropdown);
  const containerRef = useClickOutside(
    () => setIsOpenHeaderDropdown(false),
    !isOpenHeaderDropdown,
  );

  return (
    <ul className="app-header__secondary-menu">
      {reportingOutcomeFeatureFlag && isCreatorCampaignPage ? (
        <li className="app-header__menu-item">
          <BaseButton
            size="x-small"
            variant="text"
            text="Toggle Reporting Outcome"
            type="button"
            onClick={() => {
              if (setReportingOutcomeLocalStorage) {
                setReportingOutcomeLocalStorage(!reportingOutcomeLocalStorage);
              }
            }}
          />
        </li>
      ) : null}
      <li className="app-header__menu-item" ref={containerRef}>
        <button
          type="button"
          data-testid="user-menu"
          className={classNames(
            'app-header__menu-link',
            'app-header__menu-link--dropdown',
            {
              'is-open': isOpenHeaderDropdown,
            },
          )}
          onClick={toggleDropdown}
        >
          <UIIcon type="person" />
          <UIIcon type="arrow_drop_down" />
        </button>
        <ul
          className={classNames('app-header__dropdown', {
            'is-open': isOpenHeaderDropdown,
          })}
        >
          <li className="app-header__dropdown-username">{userName}</li>
          <div className="app-header__dropdown-item-divider" />
          <li>
            <Link
              to="/user/profile"
              className="app-header__dropdown-link"
              onClick={toggleDropdown}
            >
              Profile
            </Link>
          </li>
          <li>
            <Link
              to="/user/change-password"
              className="app-header__dropdown-link"
              onClick={toggleDropdown}
            >
              Change Password
            </Link>
          </li>
          <li>
            <a
              role="link"
              className="app-header__dropdown-link"
              onKeyPress={onLogout}
              onClick={onLogout}
              tabIndex={0}
              rel="noopener noreferrer"
            >
              Logout
            </a>
          </li>
        </ul>
      </li>
    </ul>
  );
}

export default AppHeaderHelpMenu;
